import { ipSkills } from '../../../data/InterPersonalSkillsData';
import ChipItem from '../components/ChipItem';

const InterpersonalSkills = () => {

	return (
		<div className='skills-container'>
			{ipSkills.map((ipSkill) => {
				return <ChipItem
					key={ipSkill.id}
					skill={ipSkill}
				/>
			})}
		</div>
	)
}

export default InterpersonalSkills;